import type { Auth0ContextInterface, User } from "@auth0/auth0-react";

import { createRootRouteWithContext, createRouter, Navigate, Outlet } from "@tanstack/react-router";
import type { CodeRouteToPath } from "@tanstack/router-core";
import type { QueryClient } from "@tanstack/react-query";

import { getContext } from "ui/Query";

import validation from "core/validation";
import ErrorBoundary from "ui/ErrorBoundary";

import auth from "areas/auth/routes";
import home from "areas/home/routes";


declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router
	}
}

export type RouterContext = {
	queryClient: QueryClient;
	auth0?: Auth0ContextInterface<User>
};

export type ValidRoutes = CodeRouteToPath<typeof router>;

export const root = createRootRouteWithContext<RouterContext>()({
	component: () => <Outlet />
});

export const tree = root.addChildren([auth, home]);

const router = createRouter({
	routeTree: tree,
	context: {
		...getContext()
	},
	defaultPreload: "intent",
	scrollRestoration: false,
	defaultStructuralSharing: true,
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: (error) => <ErrorBoundary error={error} />,
	defaultOnCatch: (e) => {
		const error = validation.serializeError(e);
		/* if (!error.type) api.error.log({ name: error.name, message: error.message, stack: stack.componentStack }); */
		return error;
	},
	defaultNotFoundComponent: () => <Navigate to="/" />
});

export default router;